module.exports = __webpack_public_path__ + "img/source05_4.f5720140.png";